import React from "react";
import "./EndingFooterMobile.css";
import ByPolko from "../../ByPolko";
import WhatsAppFAB from "../../ProductsCustomer/WhatsAppFAB";

const EndingFooterMobile = () => {
    return (
        <React.Fragment>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "95%",
                    height: '100%'
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        textAlign: "center",
                        paddingTop: '40px',
                    }}
                >
                    <h2
                        className="font-face-encode-sans-bold pink-font"
                        style={{fontSize: "25px", maxWidth: "500px"}}
                    >
                        A LA BREVEDAD UN ASESOR SE CONTACTARÁ CON USTED
                    </h2>
                </div>


                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        marginTop: "48px",
                        justifyContent: "right",

                    }}
                >
                    {/*<div style={{width: "20%"}}><ByPolko fontSize={25}/></div>*/}
                    <WhatsAppFAB/>


                </div>
            </div>
        </React.Fragment>
    );
};

export default EndingFooterMobile;
